import { Branding } from "../branding";

export const brandingValues = {
  branding: Branding.MirandaEnvios,
  httpBrand: "15",
  css: "miranda",
  segmentProduct: "miranda",
  locale: "", // used in localization
  partnerName: "Miranda Envios",
  logo: "assets/branding/miranda/logo.png",
};



// WEBPACK FOOTER //
// ./src/environment/branding/miranda.ts